import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Label,
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Checkbox,
  Input
} from 'semantic-ui-react'

const CardElectricalXrayUltrasoundUX = (props: any) => {
    return(
      <div
        id="CardElectricalXrayUltrasound"
        style={{ margin: "15px",  padding: "20px",  backgroundColor: "rgba(198, 235, 243, 0.2)" }}>
        <div
          id="CardElectricalXrayUltrasoundUX-div-1"
          style={{ paddingBottom: "5px" }}>
          
          <label
            id="CardElectricalXrayUltrasoundUX-label-2"
            style={{ fontWeight: "bold", fontSize: "18px" }}>
            {props.languageUX === "en" ? "Electrical & X-ray & Ultrasound (D-F)" : "ไฟฟ้า & เอกซเรย์ & อัลตราซาวนด์ (D-F)"}
          </label>
          <Label
            color={props.statusColor}
            id="CardElectricalXrayUltrasoundUX-Label-3"
            style={{ float: "right" }}>
            {props.status}
          </Label>
          <hr
            id="CardElectricalXrayUltrasoundUX-hr-4">
          </hr>
        </div>
        <Form
          id="CardElectricalXrayUltrasoundUX-Form-184">
          <FormGroup
            id="CardElectricalXrayUltrasoundUX-FormGroup-188"
            inline={true}>
            <FormField
              className="required"
              id="CardElectricalXrayUltrasoundUX-FormField-192"
              inline={true}
              style={{display: "flex"}}>
              <label
                id="CardElectricalXrayUltrasoundUX-label-200"
                style={{minWidth: "120px", maxWidth: "120px"}}>
                {props.languageUX === "en" ? "Surgical Cautery" : "การจี้ด้วยไฟฟ้า"}
              </label>
              <div
                id="CardElectricalXrayUltrasoundUX-div-211">
                
                <Checkbox
                  checked={props.isSurgicalCautery}
                  id="CardElectricalXrayUltrasoundUX-Checkbox-212"
                  label={props.isSurgicalCautery ? "YES" : "NO"}
                  name="is_surgical_cautery"
                  onChange={props.handleChangeData}
                  style={{minWidth: "90px", maxWidth: "90px"}}
                  toggle={true}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardElectricalXrayUltrasoundUX-FormField-196"
              inline={true}
              style={{display : props.isSurgicalCautery ? "" :"none"}}
              width={7}>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardElectricalXrayUltrasoundUX-Dropdown-207"
                multiple={true}
                name="surgical_cautery"
                onChange={props.handleChangeData}
                options={props.masterOptions?.orSurgicalCautery}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.surgicalCautery}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </Form>
        <Form
          id="CardElectricalXrayUltrasoundUX-Form-185">
          <FormGroup
            id="CardElectricalXrayUltrasoundUX-FormGroup-189"
            inline={true}>
            <FormField
              className="required"
              id="CardElectricalXrayUltrasoundUX-FormField-193"
              inline={true}
              style={{display: "flex"}}>
              <label
                id="CardElectricalXrayUltrasoundUX-label-201"
                style={{minWidth: "120px", maxWidth: "120px"}}>
                {props.languageUX === "en" ? "X-Ray" : "เอ็กซ์เรย์"}
              </label>
              <div
                id="CardElectricalXrayUltrasoundUX-div-213">
                
                <Checkbox
                  checked={props.isXray}
                  id="CardElectricalXrayUltrasoundUX-Checkbox-214"
                  label={props.isXray ? "YES" : "NO"}
                  name="is_xray"
                  onChange={props.handleChangeData}
                  style={{minWidth: "90px", maxWidth: "90px"}}
                  toggle={true}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardElectricalXrayUltrasoundUX-FormField-197"
              inline={true}
              style={{display : props.isXray ? "" :"none"}}
              width={7}>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardElectricalXrayUltrasoundUX-Dropdown-208"
                multiple={true}
                name="xray"
                onChange={props.handleChangeData}
                options={props.masterOptions?.specialEquipment}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.xay}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </Form>
        <Form
          id="CardElectricalXrayUltrasoundUX-Form-186">
          <FormGroup
            id="CardElectricalXrayUltrasoundUX-FormGroup-190"
            inline={true}>
            <FormField
              className="required"
              id="CardElectricalXrayUltrasoundUX-FormField-194"
              inline={true}
              style={{display: "flex"}}>
              <label
                id="CardElectricalXrayUltrasoundUX-label-202"
                style={{minWidth: "120px", maxWidth: "120px"}}>
                {props.languageUX === "en" ? "Ground Pad Site" : "ไซต์แผ่นรองพื้นดิน"}
              </label>
              <div
                id="CardElectricalXrayUltrasoundUX-div-221"
                style={{minWidth: "90px", maxWidth: "90px"}}>
                
                <Checkbox
                  checked={props.isGroundPadSite}
                  label={props.isGroundPadSite ? "YES" : "NO"}
                  name="is_ground_pad_site"
                  onChange={props.handleChangeData}
                  style={{minWidth: "90px", maxWidth: "90px"}}
                  toggle={true}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardElectricalXrayUltrasoundUX-FormField-198"
              inline={true}
              style={{display : props.isGroundPadSite ? "" :"none"}}
              width={7}>
              <Dropdown
                allowAdditions={true}
                clearable={true}
                fluid={true}
                id="CardElectricalXrayUltrasoundUX-Dropdown-209"
                multiple={true}
                name="ground_pad_site"
                onAddItem={props.handleAddOptions}
                onChange={props.handleChangeData}
                options={props.options?.orGroundPadSiteOption}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.groundPadSite}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </Form>
        <Form
          id="CardElectricalXrayUltrasoundUX-Form-187">
          <FormGroup
            id="CardElectricalXrayUltrasoundUX-FormGroup-191"
            inline={true}>
            <FormField
              className="required"
              id="CardElectricalXrayUltrasoundUX-FormField-195"
              inline={true}
              style={{display: "flex"}}>
              <label
                id="CardElectricalXrayUltrasoundUX-label-203"
                style={{minWidth: "120px", maxWidth: "120px"}}>
                {props.languageUX === "en" ? "U/S" : "เรา"}
              </label>
              <div
                id="CardElectricalXrayUltrasoundUX-div-215">
                {}
                <Checkbox
                  checked={props.isUs}
                  className="electricalXrayUltrasound.chkUS"
                  id="CardElectricalXrayUltrasoundUX-Checkbox-216"
                  label={props.isUs ? "YES" : "NO"}
                  name="is_us"
                  onChange={props.handleChangeData}
                  style={{minWidth: "90px", maxWidth: "90px"}}
                  toggle={true}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardElectricalXrayUltrasoundUX-FormField-199"
              inline={true}
              style={{display : props.isUs ? "" :"none" }}>
              <label
                id="CardElectricalXrayUltrasoundUX-label-217">
                {props.languageUX === "en" ? "frequency" : "ความถี่"}
              </label>
              <Input
                id="CardElectricalXrayUltrasoundUX-Input-219"
                name="frequency"
                onChange={props.handleChangeData}
                value={props.frequency}>
              </Input>
              <label
                id="CardElectricalXrayUltrasoundUX-label-218"
                style={{marginLeft: "1rem"}}>
                {props.languageUX === "en" ? "MHz" : "เมกะเฮิรตซ์"}
              </label>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardElectricalXrayUltrasoundUX-div-154"
          style={{ height: "55px", paddingTop: "15px" }}>
          
          <div
            id="CardElectricalXrayUltrasoundUX-div-155"
            style={{display:"flex",justifyContent:"flex-end"}}>
            
            <div
              id="CardElectricalXrayUltrasoundUX-div-181"
              style={{margin:"10px"}}>
              {props.buttonSave}
            </div>
            <div
              id="CardElectricalXrayUltrasoundUX-div-182"
              style={{margin:"10px"}}>
              {props.buttonConfirm}
            </div>
            <div
              id="CardElectricalXrayUltrasoundUX-div-183"
              style={{margin:"10px"}}>
              {props.buttonUnconfirm}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardElectricalXrayUltrasoundUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasound"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\",  padding: \"20px\",  backgroundColor: \"rgba(198, 235, 243, 0.2)\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"5px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "ไฟฟ้า & เอกซเรย์ & อัลตราซาวนด์ (D-F)",
          "valueEN": "Electrical & X-ray & Ultrasound (D-F)"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Label",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.status"
        },
        "color": {
          "type": "code",
          "value": "props.statusColor"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-Label-3"
        },
        "style": {
          "type": "code",
          "value": "{ float: \"right\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-hr-4"
        }
      },
      "seq": 4,
      "void": true
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-div-154"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"55px\", paddingTop: \"15px\" }"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-div-155"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",justifyContent:\"flex-end\"}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-div-181"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-div-182"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUnconfirm"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-div-183"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 184,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-Form-184"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 185,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-Form-185"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 186,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-Form-186"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 187,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-Form-187"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 188,
      "name": "FormGroup",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-FormGroup-188"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 189,
      "name": "FormGroup",
      "parent": 185,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-FormGroup-189"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 190,
      "name": "FormGroup",
      "parent": 186,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-FormGroup-190"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 191,
      "name": "FormGroup",
      "parent": 187,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-FormGroup-191"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 192,
      "name": "FormField",
      "parent": 188,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-FormField-192"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 193,
      "name": "FormField",
      "parent": 189,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-FormField-193"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 194,
      "name": "FormField",
      "parent": 190,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-FormField-194"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 195,
      "name": "FormField",
      "parent": 191,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-FormField-195"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "FormField",
      "parent": 188,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-FormField-196"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display : props.isSurgicalCautery ? \"\" :\"none\"}"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "FormField",
      "parent": 189,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-FormField-197"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display : props.isXray ? \"\" :\"none\"}"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 198,
      "name": "FormField",
      "parent": 190,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-FormField-198"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display : props.isGroundPadSite ? \"\" :\"none\"}"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 199,
      "name": "FormField",
      "parent": 191,
      "props": {
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-FormField-199"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display : props.isUs ? \"\" :\"none\" }"
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": null,
      "id": 200,
      "name": "label",
      "parent": 192,
      "props": {
        "children": {
          "type": "value",
          "value": "การจี้ด้วยไฟฟ้า",
          "valueEN": "Surgical Cautery"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-label-200"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"120px\", maxWidth: \"120px\"}"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": null,
      "id": 201,
      "name": "label",
      "parent": 193,
      "props": {
        "children": {
          "type": "value",
          "value": "เอ็กซ์เรย์",
          "valueEN": "X-Ray"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-label-201"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"120px\", maxWidth: \"120px\"}"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": null,
      "id": 202,
      "name": "label",
      "parent": 194,
      "props": {
        "children": {
          "type": "value",
          "value": "ไซต์แผ่นรองพื้นดิน",
          "valueEN": "Ground Pad Site"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-label-202"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"120px\", maxWidth: \"120px\"}"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": null,
      "id": 203,
      "name": "label",
      "parent": 195,
      "props": {
        "children": {
          "type": "value",
          "value": "เรา",
          "valueEN": "U/S"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-label-203"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"120px\", maxWidth: \"120px\"}"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 207,
      "name": "Dropdown",
      "parent": 196,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-Dropdown-207"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "surgical_cautery"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.orSurgicalCautery"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.surgicalCautery"
        }
      },
      "seq": 207,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 208,
      "name": "Dropdown",
      "parent": 197,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-Dropdown-208"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "xray"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.specialEquipment"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.xay"
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 209,
      "name": "Dropdown",
      "parent": 198,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-Dropdown-209"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "ground_pad_site"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.handleAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.options?.orGroundPadSiteOption"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.groundPadSite"
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": null,
      "id": 211,
      "name": "div",
      "parent": 192,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-div-211"
        }
      },
      "seq": 211,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 212,
      "name": "Checkbox",
      "parent": 211,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isSurgicalCautery"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-Checkbox-212"
        },
        "label": {
          "type": "code",
          "value": "props.isSurgicalCautery ? \"YES\" : \"NO\""
        },
        "name": {
          "type": "value",
          "value": "is_surgical_cautery"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"90px\", maxWidth: \"90px\"}"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": null,
      "id": 213,
      "name": "div",
      "parent": 193,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-div-213"
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 214,
      "name": "Checkbox",
      "parent": 213,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isXray"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-Checkbox-214"
        },
        "label": {
          "type": "code",
          "value": "props.isXray ? \"YES\" : \"NO\""
        },
        "name": {
          "type": "value",
          "value": "is_xray"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"90px\", maxWidth: \"90px\"}"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": null,
      "id": 215,
      "name": "div",
      "parent": 195,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-div-215"
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 216,
      "name": "Checkbox",
      "parent": 215,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isUs"
        },
        "className": {
          "type": "value",
          "value": "electricalXrayUltrasound.chkUS"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-Checkbox-216"
        },
        "label": {
          "type": "code",
          "value": "props.isUs ? \"YES\" : \"NO\""
        },
        "name": {
          "type": "value",
          "value": "is_us"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"90px\", maxWidth: \"90px\"}"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": null,
      "id": 217,
      "name": "label",
      "parent": 199,
      "props": {
        "children": {
          "type": "value",
          "value": "ความถี่",
          "valueEN": "frequency"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-label-217"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": null,
      "id": 218,
      "name": "label",
      "parent": 199,
      "props": {
        "children": {
          "type": "value",
          "value": "เมกะเฮิรตซ์",
          "valueEN": "MHz"
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-label-218"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 219,
      "name": "Input",
      "parent": 199,
      "props": {
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-Input-219"
        },
        "name": {
          "type": "value",
          "value": "frequency"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.frequency"
        }
      },
      "seq": 218,
      "void": false
    },
    {
      "from": null,
      "id": 221,
      "name": "div",
      "parent": 194,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardElectricalXrayUltrasoundUX-div-221"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"90px\", maxWidth: \"90px\"}"
        }
      },
      "seq": 221,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 222,
      "name": "Checkbox",
      "parent": 221,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isGroundPadSite"
        },
        "label": {
          "type": "code",
          "value": "props.isGroundPadSite ? \"YES\" : \"NO\""
        },
        "name": {
          "type": "value",
          "value": "is_ground_pad_site"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"90px\", maxWidth: \"90px\"}"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 222,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardElectricalXrayUltrasoundUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
